export const recentTrxnsFields = {
    columns: [
        {
            title: 'TRSN ID', field: 'transaction_id', cellStyle: {
                minWidth: 250,
                maxWidth: 250
            }
        },
        { title: 'Amount', field: 'amount' },
        { title: 'Telco', field: 'telco' },
        { title: 'TRSN Type', field: 'vend_type' },
        {
            title: 'Status', field: 'transaction_message', cellStyle: {
                minWidth: 200,
                maxWidth: 200
            }
        }
    ]
}

export const trxnsFields = {
    columns: [
        {
            title: 'TRSN ID', field: 'transaction_id', sorting: false, filtering: false, cellStyle: {
                minWidth: 250,
                maxWidth: 250
            }
        },
        { title: 'Amount', field: 'amount' },
        { title: 'Phone No.', field: 'phone_no', sorting: false },
        { title: 'Vend Code', field: 'vend_code' },
        { title: 'Date & Time', field: 'transaction_date', filtering: false },
        { title: 'Telco', field: 'telco', lookup: { MTN: 'MTN', Airtel: 'Airtel', '9Mobile': '9Mobile', Glo: 'Glo' } },
        { title: 'TRSN Type', field: 'vend_type', lookup: { Airtime: 'Airtime', Data: 'Data' } },
        {
            title: 'Status', field: 'transaction_message', cellStyle: {
                minWidth: 190,
                maxWidth: 190
            }
        }
    ]
}

export const userFields = {
    columns: [
        {
            title: 'Username', field: 'username', cellStyle: {
                minWidth: 280,
                maxWidth: 280
            }
        },
        {
            title: 'Client', field: 'agentName', cellStyle: {
                minWidth: 320,
                maxWidth: 320
            }
        },
        { title: 'Role', field: 'role' },
        { title: 'Name', field: 'name' },
        { title: 'Password', field: 'passwd', hidden: true },
        { title: 'Phone No.', field: 'phoneNo', hidden: true },
        {
            title: 'Last Active', field: 'loginDate', cellStyle: {
                minWidth: 150,
                maxWidth: 150
            }
        },
    ]
}

export const topUpFields = {
    columns: [
        {
            title: 'Id', field: 'id', hidden: true
        },
        {
            title: 'Agent ID', field: 'agentId', hidden: true
        },
        {
            title: 'Client', field: 'agentName', cellStyle: {
                minWidth: 320,
                maxWidth: 320
            }
        },
        { title: 'Amount', field: 'amount' },
        {
            title: 'Topup Date', field: 'topupDate', cellStyle: {
                minWidth: 150,
                maxWidth: 150
            }
        },
        { title: 'Topup By', field: 'topupBy' }
    ]
}